import { useCallback } from "react";

import useRestMutation from "@/remoteState/useRestMutation";

export const PARNASSUS_HOST =
  process.env.NEXT_PUBLIC_PARNASSUS_URL || "/parnassus/api/v2";
const useChallengeReportStudentsGet = () => {
  const createEventRecordRequest = useCallback((params) => {
    const challengeId = params.challengeId;
    const classroomId = params.classroomId;

    const baseUrl = `${PARNASSUS_HOST}/challenges/${challengeId}/report/students`;

    const queryParams =
      classroomId !== undefined ? `?classroom_id=${classroomId}` : "";

    const url = `${baseUrl}${queryParams}`;

    const requestConfig = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useChallengeReportStudentsGet;
